<template>
  <div style="width: 300px;">
    <div class="container">
      <div class="row">
        <div class="col">
          <img id="logo" src="../assets/logo.png" />
        </div>
        <div class="col">
          <div v-if="$store.getters.user.email" id="slider-dots-group" class="float-right">
            <slider-switch
              class="mr-1"
              v-bind:selected="$store.getters.running"
              @click="toggleRunning()"
            ></slider-switch>
          </div>
        </div>
      </div>
    </div>
    <div class="row nav-bar no-gutters">
      <nav-button class="col" name="home" color="#51b847" :disabled="!this.loggedIn"></nav-button>
      <nav-button class="col" name="settings" color="#51b847" :disabled="!this.loggedIn"></nav-button>
      <nav-button class="col" name="BCC" color="#51b847"></nav-button>
      <nav-button class="col" name="account" color="#51b847"></nav-button>
      <nav-button v-if="$store.getters.devMode" class="col" name="dev" color="#51b847"></nav-button>
    </div>
    <b-container style="overflow-y: scroll; max-height: 398px;">
      <slot />
    </b-container>
  </div>
</template>

<script>
import SliderSwitch from "../tools/SliderSwitch";
import NavButton from "../tools/NavButton";

export default {
  name: "Structure",
  components: {
    SliderSwitch,
    NavButton
  },
  data() {
    return {
      loggedIn: true
    };
  },
  mounted() {
    setTimeout(() => {
      if (this.$store.getters.user.email) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
      console.log("activity date ", this.$store.getters.activityDate);
      var dateObj = new Date();
      let today = dateObj.getDate();
      if (this.$store.getters.activityDate !== today) {
        console.log("updaing activity date to ", today);
        this.$store.commit("setActivityDate");
      }
    }, 50);
  },
  methods: {
    toggleRunning() {
      this.$store.commit("toggleRunning");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pointer {
  cursor: pointer;
}
#logo {
  height: 22px;
  margin: 15px;
}
#on-off-switch {
  position: relative;
}
#menu-dots {
  height: 18px;
}
#slider-dots-group {
  margin-top: 12px;
}
.nav-bar {
  background-color: #212529;
  height: 50px;
}
</style>
